import React, { useEffect, useState } from 'react';
import { Inbox, Loader2 } from 'lucide-react';
import { SubmissionCard } from './SubmissionCard';
import { WelcomeMessageEditor } from './WelcomeMessageEditor';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SubmissionsPage = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/design-submissions`, { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setSubmissions(Array.isArray(data) ? data : []))
      .catch(() => setSubmissions([]))
      .finally(() => setLoading(false));
  }, []);

  let content;
  if (loading) {
    content = (
      <div className="flex justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-[#7B1E2B]" />
      </div>
    );
  } else if (submissions.length === 0) {
    content = (
      <div data-testid="no-submissions" className="bg-white rounded-lg shadow-md p-12 text-center text-gray-500">
        No submissions yet. Share the customizer link with your client to get started.
      </div>
    );
  } else {
    content = (
      <div className="space-y-6" data-testid="submissions-list">
        {submissions.map((sub) => (
          <SubmissionCard key={sub.id} sub={sub} />
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#001B2A] text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl font-serif font-bold flex items-center gap-3">
            <Inbox className="h-8 w-8" />
            Client Design Submissions
          </h1>
          <p className="text-white/70 mt-2">All selections, info, and files submitted by your web design clients</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <WelcomeMessageEditor />
        {content}
      </div>
    </div>
  );
};

export default SubmissionsPage;
